import { MediaImage } from 'editor/src/store/design/types';
import { RootState } from 'editor/src/store/index';

import getMediaElementByUuid from './getMediaElementByUuid';

const getAdjustmentByUuid = (state: RootState, uuid: number, name: string) =>
  (getMediaElementByUuid(state, uuid) as MediaImage)?.adjustments?.find((element) => element.name === name)?.value;

export default getAdjustmentByUuid;
